import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=80363f0c"
import script from "./EmailDialog.vue?vue&type=script&lang=ts"
export * from "./EmailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports